<template>
  <a
    v-bind:href="href"
    v-bind:class="currentClasses"
    v-on:click="go"
  >
    <slot></slot>
  </a>
</template>

<script>
  import routes from '../SettingsPage.vue'
  export default {
    props: {
      href: {
        type:String,
        required: true
      },
      defaultClasses: {
        type:String,
        required: false,
      },
      activeClasses: {
        type:String,
        required: false,
      },
      currentRoute: {
        type:String,
        required: false,
      },
    },
    computed: {
      isActive () {
        let startPage = this.currentRoute === '/' && this.href === '/';
        let otherPage = this.currentRoute.indexOf(this.href) !== -1 && this.href !== '/';
        return startPage || otherPage;
      },
      currentClasses() {
        if (this.isActive) {
          return this.activeClasses;
        } else {
          return this.defaultClasses;
        }
      }
    },
    methods: {
      go (event) {
        event.preventDefault()
        this.$emit('href-change', this.href);
        window.history.pushState(
          null,
          routes[this.href],
          this.href
        )
      }
    }
  }
</script>
